import React, { JSX } from 'react';
import { Platform, Pressable } from 'react-native';
import { AntDesign } from '@expo/vector-icons';
import * as Animatable from 'react-native-animatable';
import _, { uniqueId } from 'lodash';
import styles from '@stylesheet';
import { Text } from 'tamagui';

export type ActionTypeProps = { 
  function: (e) => void;
  icon: string | JSX.Element;
  color?: string;
  hint?: string;
  label?: string;
  labelColor?: string;
  special?: JSX.Element;
};

export type ActionButtonProps = {
  action: ActionTypeProps;
  index?: number;
  large?: boolean;
  color?: string;
  noBackground?: boolean;
  disabled?: boolean;
  row?: boolean;
  active?: boolean;
  noBorder?: boolean;
  removeWidthConstraint?: boolean;
  showLabel?: boolean;
  labelOrientation?: 'inline' | 'below';
  pill?: boolean;
};

const ActionButton = ({ noBackground, noBorder, active, action, index, large, color, disabled, removeWidthConstraint, showLabel, labelOrientation = 'inline', pill = false }: ActionButtonProps) => {

  if (action.special) {
    return (
      <>
        {action.special}
      </>
    )
  }

  const [hovered, setHovered] = React.useState(false);
  const [colorState, setColorState] = React.useState(color);
  const uuid = uniqueId();

  const handlePress = (e) => {
    action.function?.(e);
  };

  const shouldShowLabel = showLabel && action.label;
  const flexDirection = shouldShowLabel && labelOrientation === 'inline' ? 'row' : 'column';

  return (
    <Pressable
      onPress={(e) => { if (!disabled) { handlePress?.(e) } }}
      key={index+ uuid}
      accessibilityHint={action.hint}
      onBlur={() => setHovered(false)}
      // onPressIn={handlePressIn}
      // onPressOut={handlePressOut}
      style={[
        styles.LoginButton,
        {
          minHeight: large ? 80 : 50,
          minWidth: removeWidthConstraint ? undefined : (large ? 80 : 50),
          maxHeight: large ? 80 : 50,
          maxWidth: removeWidthConstraint ? undefined : (large ? 80 : 50),
          flex: removeWidthConstraint ? 1 : undefined,
          shadowOpacity: 0,
          borderWidth: 0,
          borderColor: "transparent",
          backgroundColor: "transparent",
          padding: 5,
          paddingVertical: 2,
          borderRadius: !noBorder && (pill ? 9999 : 10),
          marginHorizontal: 0,
          alignItems: 'center',
          justifyContent: 'center',
          transform: [{ scale: Platform.OS != 'web' ? 0.8 : 1 }]
        }
      ]}
    >
      {({ hovered }) => (
        <Animatable.View 
          transition={['backgroundColor']}
          duration={200}
          style={[styles.centerEverything, {
            minHeight: shouldShowLabel && labelOrientation === 'below' ? undefined : (large ? 80 : 50),
            minWidth: removeWidthConstraint ? undefined : (large ? 80 : 50),
            maxHeight: shouldShowLabel && labelOrientation === 'below' ? undefined : (large ? 80 : 50),
            maxWidth: removeWidthConstraint ? undefined : (large ? 80 : 50),
            flex: removeWidthConstraint ? 1 : undefined,
            alignSelf: removeWidthConstraint ? 'stretch' : undefined,
            backgroundColor: noBackground ? undefined : (hovered || active ? 'lightblue' : '#ececec'),
            margin: 4,
            paddingVertical: pill ? 8 : 10,
            paddingHorizontal: pill ? 12 : 10,
            borderRadius: pill ? 9999 : 10,
            flexDirection: flexDirection,
            gap: 8,
            alignItems: 'center',
            justifyContent: 'center'
          }]}
        >
          {
            typeof action.icon === 'string' ?
              <AntDesign
                name={action.icon}
                size={24}
                style={{
                  paddingHorizontal: 5,
                  paddingVertical: 2,
                  minWidth: removeWidthConstraint ? undefined : 40,
                  left: labelOrientation === 'inline' ? 3 : 0
                }}
                color={action.color || colorState}
              />
            :
            action.icon
          }
          {
            shouldShowLabel && (
              <Text style={{
                textAlign: 'center',
                fontSize: labelOrientation === 'inline' ? 12 : 10,
                color: action.labelColor || (hovered || active ? 'black' : '#666'),
                fontWeight: '500',
                flexShrink: 1
              }}>
                {action.label}
              </Text>
            )
          }
        </Animatable.View>
      )}
    </Pressable>
  );
};

export default ActionButton;
